export default __webpack_public_path__ + "static/media/tablefilter_black.5c47deeb.svg";